content_info_array